import { DOCS_URL } from "../../../config/constants";
import { ETitleFontSizes } from "../../../config/enums";
import uploadToMuxHero from "../../../utils/uploadToMuxHero";
import uploadToMuxHeroMobile from "../../../utils/uploadToMuxHeroMobile";
import Hero from "./Hero.svelte";

export default {
    component: Hero,
    name: "Hero - Block",
    description: "Full-width hero section with background media and content overlay",
    image: "https://unpkg.com/@tabler/icons@3.5.0/icons/outline/movie.svg",
    docsLink: `${DOCS_URL}/storybook/?path=/docs/organisms-hero--docs`,
    screenshot:
        "https://cdn.builder.io/api/v1/image/assets%2F5d0546160e954b87b82e2663451afcb1%2F5999de0a46e24f26acc17cfde5064370",
    inputs: [
        {
            friendlyName: "Content",
            name: "content",
            type: "longText",
        },
        {
            friendlyName: "Heading Level (Semantic)",
            name: "headingLevel",
            type: "text",
            enum: ["h1", "h2", "h3", "h4", "h5", "h6"],
            defaultValue: "h1",
            helperText: "Select the semantic HTML heading level for SEO and accessibility",
        },
        {
            friendlyName: "Title Font Size",
            name: "titleSize",
            type: "text",
            enum: Object.values(ETitleFontSizes),
            defaultValue: ETitleFontSizes.H1,
        },
        {
            friendlyName: "Text Colour",
            name: "mastheadTextColour",
            type: "color",
        },
        {
            friendlyName: "CTA Link 1",
            name: "link",
            type: "string",
        },
        {
            friendlyName: "CTA Text 1",
            name: "linkText",
            type: "string",
        },
        {
            friendlyName: "CTA Link 2",
            name: "link2",
            type: "string",
        },
        {
            friendlyName: "CTA Text 2",
            name: "linkText2",
            type: "string",
        },
        {
            friendlyName: "Inverse Button Colours?",
            name: "inverseButtonColours",
            type: "boolean",
        },
        {
            friendlyName: "Video",
            helperText:
                "Recommended 19:8. This is cropped to the desktop hero frame; upload a separate mobile video for mobile.",
            name: "src",
            onChange: uploadToMuxHero,
            type: "file",
            allowedFileTypes: ["mov", "webm", "mp4"],
            defaultValue:
                "https://uploads-ssl.webflow.com/5edf57ee4dfb0a51188bd460/62ac399d5f9eb92c4c5722d6_ShowReel v09-transcode.mp4",
        },
        {
            friendlyName: "Video Poster Image",
            name: "poster",
            helperText: "Recommended 19:8 to match the desktop video frame.",
            type: "file",
            allowedFileTypes: ["jpg", "jpeg", "png", "gif", "webp"],
            defaultValue: "https://placehold.co/400",
        },
        {
            friendlyName: "Mobile Video",
            helperText: "Recommended 27:43. Leave empty to reuse the desktop video on mobile.",
            name: "mobileSrc",
            type: "file",
            allowedFileTypes: ["mov", "webm", "mp4"],
            defaultValue: "",
            onChange: uploadToMuxHeroMobile,
        },
        {
            friendlyName: "Video Poster Image - Mobile",
            name: "posterMobile",
            helperText: "Recommended 27:43 to match the mobile video frame.",
            type: "file",
            allowedFileTypes: ["jpg", "jpeg", "png", "gif", "webp"],
            defaultValue: "https://placehold.co/400",
        },
        {
            friendlyName: "Mux Video ID",
            helperText:
                "Recommended 19:8. This is cropped to the desktop hero frame; use a separate mobile Mux ID for mobile.",
            name: "muxId",
            type: "text",
            hidden: true,
        },
        {
            friendlyName: "Mux Mobile Video ID",
            helperText: "Recommended 27:43. Leave empty to reuse the desktop Mux ID on mobile.",
            name: "muxIdMobile",
            type: "text",
            hidden: true,
        },
        {
            friendlyName: "Desktop Image",
            name: "image",
            type: "object",
            helperText: "3:1 Aspect Ratio",
            subFields: [
                {
                    friendlyName: "Source",
                    name: "src",
                    type: "file",
                    allowedFileTypes: ["jpg", "jpeg", "png", "gif", "webp"],
                    defaultValue: "https://placehold.co/400",
                    required: true,
                },
                {
                    friendlyName: "Alt",
                    name: "alt",
                    type: "text",
                },
            ],
        },
        {
            friendlyName: "Mobile Image",
            name: "mobileImage",
            type: "object",
            helperText: "1:1 Aspect Ratio",
            subFields: [
                {
                    friendlyName: "Source",
                    name: "src",
                    type: "file",
                    allowedFileTypes: ["jpg", "jpeg", "png", "gif", "webp"],
                    defaultValue: "https://placehold.co/400",
                    required: true,
                },
                {
                    friendlyName: "Alt",
                    name: "alt",
                    type: "text",
                },
            ],
        },
    ],
};
